/**
 * Blossom — search.js
 * Glue for the header search overlay (drawer id "SearchDrawer"):
 *  - lazily loads predictive-search.js the first time search is opened,
 *    hovered or focused (it is not needed for first paint)
 *  - focuses the search input on open
 *  - "/" keyboard shortcut opens search (ignored while typing in a field)
 * Without JavaScript the header search icon links to the search page.
 */
(() => {
  if (!window.Theme || Theme.searchInitialized) return;
  Theme.searchInitialized = true;

  const DRAWER_ID = 'SearchDrawer';
  const drawer = () => document.getElementById(DRAWER_ID);

  const loadPredictiveSearch = () => {
    const source = drawer()?.querySelector('[data-predictive-script]')?.dataset.predictiveScript;
    if (!source || !Theme.settings.predictiveSearch) return;
    // The plain search form keeps working if the script fails to load.
    Theme.loadScript(source).catch(() => {});
  };

  Theme.on(Theme.events.DRAWER_OPEN, (event) => {
    if (event.detail?.id !== DRAWER_ID) return;
    loadPredictiveSearch();
    const input = drawer()?.querySelector('input[type="search"]');
    if (input) {
      requestAnimationFrame(() => {
        input.focus({ preventScroll: true });
        input.select();
      });
    }
  });

  // Warm up the script on intent (hover / keyboard focus on a search toggle).
  const warmUp = (event) => {
    if (event.target.closest?.(`[aria-controls="${DRAWER_ID}"]`)) loadPredictiveSearch();
  };
  document.addEventListener('pointerover', warmUp, { passive: true });
  document.addEventListener('focusin', warmUp);

  document.addEventListener('keydown', (event) => {
    if (event.key !== '/' || event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey) return;
    if (event.target.closest?.('input, textarea, select, [contenteditable="true"]')) return;
    const searchDrawer = drawer();
    if (!searchDrawer || typeof searchDrawer.open !== 'function' || searchDrawer.isOpen) return;
    if (document.querySelector('dialog[open]')) return;
    event.preventDefault();
    searchDrawer.open(document.querySelector(`[aria-controls="${DRAWER_ID}"]`));
  });
})();
